








import { defineComponent, computed } from '@nuxtjs/composition-api'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  setup() {
    const i18n = useI18n()

    const taglineText = computed(() =>
      i18n.locale === 'el'
        ? 'Δωρεάν αναζήτηση & καταχώριση αγγελιών'
        : 'Free search & classifieds posting'
    )

    return { taglineText }
  }
})
